import request from '@/utils/request'

export function getQuotations(param) {

  const data = param
  
  return request({
    url: `/zdmin/epms0100/getQuotations`,
    method: 'POST',
    meta: {
      apiVersion: '1.0.0'
    },
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    },
    data
  })

}

export function getPI(param) {

  const data = param
  
  return request({
    url: `/zdmin/epms0100/getPI`,
    method: 'POST',
    meta: {
      apiVersion: '1.0.0'
    },
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    },
    data
  })
  
}

export function getBidding(param) {

  const data = param
  
  return request({
    url: `/zdmin/epms0100/getBidding`,
    method: 'POST',
    meta: {
      apiVersion: '1.0.0'
    },
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    },
    data
  })
  
}

export function getSuccess(param) {

  const data = param
  
  return request({
    url: `/zdmin/epms0100/getSuccess`,
    method: 'POST',
    meta: {
      apiVersion: '1.0.0'
    },
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    },
    data
  })
  
}

export function getPO(param) {

  const data = param
  
  return request({
    url: `/zdmin/epms0100/getPO`,
    method: 'POST',
    meta: {
      apiVersion: '1.0.0'
    },
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    },
    data
  })
  
}

export function getDelPlanCnt(param) {

  const data = param
  
  return request({
    url: `/zdmin/epms0100/getDelPlanCnt`,
    method: 'POST',
    meta: {
      apiVersion: '1.0.0'
    },
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    },
    data
  })
  
}

export function getDelOrderCnt(param) {

  const data = param
  
  return request({
    url: `/zdmin/epms0100/getDelOrderCnt`,
    method: 'POST',
    meta: {
      apiVersion: '1.0.0'
    },
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    },
    data
  })
  
}

export function getDemMarkCnt(param) {

  const data = param
  
  return request({
    url: `/zdmin/epms0100/getDemMarkCnt`,
    method: 'POST',
    meta: {
      apiVersion: '1.0.0'
    },
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    },
    data
  })
  
}

export function getNoticeList() {

  return request({
    url: `/zdmin/epms0100/getNoticeList`,
    method: 'POST',
    meta: {
      apiVersion: '1.0.0'
    },
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    }
  })

}

export function getBuyerList() {

  return request({
    url: `/zdmin/epms0100/getBuyerList`,
    method: 'POST',
    meta: {
      apiVersion: '1.0.0'
    },
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    }
  })

}

// export function getCheckSurvey(param) {

//   const data = param
  
//   return request({
//     url: `/zdmin/epms0100/getCheckSurvey`,
//     method: 'POST',
//     meta: {
//       apiVersion: '1.0.0'
//     },
//     headers: {
//       'Content-Type': 'application/json;charset=utf8'
//     },
//     data
//   })
  
// }